<template>
    <div class="error" :style="style">
        <h3>{{showTitle}}</h3>
        <p>{{showMessage}}</p>
    </div>
</template>

<script>
export default {
  props: ['height', 'message', 'title'],
  computed: {
    style() {
      const height = this.height ? this.height + 'px;' : '100%';
      return `height: ${height}`;
    },
    showTitle() {
      return this.title ? this.title : 'Error';
    },
    showMessage() {
      return this.message ? this.message : 'An unknown error occurred.';
    }
  }
};
</script>
